// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-primary: #01978d;
  --brand-secondary: #007bff;
  --text-dark: #1f2937;
  --text-muted: #6b7280;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --shadow-color: rgba(0, 0, 0, 0.08);
}

.sr-only {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

body {
  font-family: 'Inter', sans-serif;
  margin: 0;
  background-color: var(--bg-light);
}


.login-viewport {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(1, 151, 141, 0.05) 0%, rgba(245, 158, 11, 0.03) 50%, var(--bg-light) 100%);
  padding: 1rem;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.bg-decor {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-decor .drop {
  position: absolute;
  background: radial-gradient(circle at 30% 30%, var(--brand-highlight), var(--brand-primary));
  border-radius: 60% 40% 70% 30% / 40% 60% 30% 70%;
  opacity: 0.08;
  filter: blur(1px);
  animation: wobble 10s ease-in-out infinite alternate, floaty 15s ease-in-out infinite;
}

.bg-decor .d1 {
  width: 150px;
  height: 150px;
  left: 5%;
  top: 10%;
}

.bg-decor .d2 {
  width: 100px;
  height: 100px;
  right: 10%;
  top: 30%;
  background: radial-gradient(circle at 30% 30%, var(--brand-primary), var(--brand-highlight));
}

.bg-decor .d3 {
  width: 180px;
  height: 180px;
  left: 20%;
  bottom: 15%;
}

.bg-decor .d4 {
  width: 90px;
  height: 90px;
  right: 25%;
  bottom: 5%;
  background: radial-gradient(circle at 30% 30%, var(--brand-primary), var(--brand-highlight));
}

.bg-decor .d5 {
  width: 120px;
  height: 120px;
  left: 40%;
  top: 5%;
  animation-delay: 12s;
}

@keyframes floaty {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-20px) scale(1.02);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes wobble {

  0%,
  100% {
    border-radius: 60% 40% 70% 30% / 40% 60% 30% 70%;
    transform: rotate(0deg);
  }

  50% {
    border-radius: 40% 60% 30% 70% / 70% 30% 60% 40%;
    transform: rotate(5deg) scale(1.01);
  }
}

.login-wrapper {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 380px;
  text-align: center;
}

.brand-section {
  margin-bottom: 1.5rem;
}

.app-title {
  font-size: 2.2rem;
  margin: 0;
  color: var(--text-dark);
  font-weight: 800;
  letter-spacing: -0.05em;
}

.app-title-highlight {
  color: var(--brand-primary);
}

.app-subtext {
  margin: 0.5rem 0 0 0;
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.4;
}

.login-card {
  background: var(--card-bg);
  border-radius: 1.5rem;
  padding: 2rem 1.5rem 1.5rem;
  box-shadow: 0 15px 40px var(--shadow-color);
  border: 1px solid var(--border-light);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  animation: cardIn 420ms cubic-bezier(0.16, 0.84, 0.32, 1);
}

@keyframes cardIn {
  from {
    transform: translateY(20px) scale(0.98);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.input-group {
  width: 100%;
}

.input-with-icon {
  display: flex;
  align-items: center;
  background-color: var(--bg-light);
  border: 1px solid var(--border-light);
  border-radius: 0.75rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  position: relative; 
}

.input-with-icon:focus-within {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.2);
}

.input-icon {
  padding: 0 0.5rem 0 1rem; 
  color: var(--text-muted);
  font-size: 1rem;
}

.login-input {
  flex-grow: 1; 
  width: 100%;
  border: none;
  background: transparent;
  padding: 0.85rem 0; 
  font-size: 1rem;
  color: var(--text-dark);
  outline: none; 
}

.login-input::placeholder {
  color: var(--text-muted);
}

.login-input:focus {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.2);
}

.password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
}

.password-toggle:hover {
  color: var(--brand-primary);
}

.forgot-password-row {
  text-align: right;
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
}

.forgot-password-link {
  background: none;
  border: none;
  color: var(--text-muted);
  font-size: 0.875rem;
  text-decoration: none;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.forgot-password-link:hover {
  color: var(--brand-primary);
  background-color: var(--bg-light);
}

.login-btn {
  margin-top: 0.5rem;
  background: linear-gradient(90deg, var(--brand-primary), #02b6a7);
  color: white;
  padding: 0.9rem 1.5rem;
  border-radius: 9999px;
}

.company-logo-wrapper {
  margin-top: 2rem;
  text-align: center;
}

.company-logo {
  max-width: 160px;
  width: 100%;
  height: auto;
  opacity: 0.75;
}`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,iCAAiC;AACnC;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mHAAmH;EACnH,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4FAA4F;EAC5F,gDAAgD;EAChD,aAAa;EACb,iBAAiB;EACjB,qFAAqF;AACvF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,QAAQ;EACR,4FAA4F;AAC9F;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,4FAA4F;AAC9F;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;;IAEE,gDAAgD;IAChD,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;IAChD,mCAAmC;EACrC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,2CAA2C;EAC3C,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yDAAyD;AAC3D;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qCAAqC;EACrC,sBAAsB;EACtB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iEAAiE;EACjE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;AACf","sourcesContent":[":root {\n  --brand-primary: #01978d;\n  --brand-secondary: #007bff;\n  --text-dark: #1f2937;\n  --text-muted: #6b7280;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-light: #e5e7eb;\n  --shadow-color: rgba(0, 0, 0, 0.08);\n}\n\n.sr-only {\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n  white-space: nowrap;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  margin: 0;\n  background-color: var(--bg-light);\n}\n\n\n.login-viewport {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, rgba(1, 151, 141, 0.05) 0%, rgba(245, 158, 11, 0.03) 50%, var(--bg-light) 100%);\n  padding: 1rem;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.bg-decor {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.bg-decor .drop {\n  position: absolute;\n  background: radial-gradient(circle at 30% 30%, var(--brand-highlight), var(--brand-primary));\n  border-radius: 60% 40% 70% 30% / 40% 60% 30% 70%;\n  opacity: 0.08;\n  filter: blur(1px);\n  animation: wobble 10s ease-in-out infinite alternate, floaty 15s ease-in-out infinite;\n}\n\n.bg-decor .d1 {\n  width: 150px;\n  height: 150px;\n  left: 5%;\n  top: 10%;\n}\n\n.bg-decor .d2 {\n  width: 100px;\n  height: 100px;\n  right: 10%;\n  top: 30%;\n  background: radial-gradient(circle at 30% 30%, var(--brand-primary), var(--brand-highlight));\n}\n\n.bg-decor .d3 {\n  width: 180px;\n  height: 180px;\n  left: 20%;\n  bottom: 15%;\n}\n\n.bg-decor .d4 {\n  width: 90px;\n  height: 90px;\n  right: 25%;\n  bottom: 5%;\n  background: radial-gradient(circle at 30% 30%, var(--brand-primary), var(--brand-highlight));\n}\n\n.bg-decor .d5 {\n  width: 120px;\n  height: 120px;\n  left: 40%;\n  top: 5%;\n  animation-delay: 12s;\n}\n\n@keyframes floaty {\n  0% {\n    transform: translateY(0px);\n  }\n\n  50% {\n    transform: translateY(-20px) scale(1.02);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes wobble {\n\n  0%,\n  100% {\n    border-radius: 60% 40% 70% 30% / 40% 60% 30% 70%;\n    transform: rotate(0deg);\n  }\n\n  50% {\n    border-radius: 40% 60% 30% 70% / 70% 30% 60% 40%;\n    transform: rotate(5deg) scale(1.01);\n  }\n}\n\n.login-wrapper {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  max-width: 380px;\n  text-align: center;\n}\n\n.brand-section {\n  margin-bottom: 1.5rem;\n}\n\n.app-title {\n  font-size: 2.2rem;\n  margin: 0;\n  color: var(--text-dark);\n  font-weight: 800;\n  letter-spacing: -0.05em;\n}\n\n.app-title-highlight {\n  color: var(--brand-primary);\n}\n\n.app-subtext {\n  margin: 0.5rem 0 0 0;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.login-card {\n  background: var(--card-bg);\n  border-radius: 1.5rem;\n  padding: 2rem 1.5rem 1.5rem;\n  box-shadow: 0 15px 40px var(--shadow-color);\n  border: 1px solid var(--border-light);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  animation: cardIn 420ms cubic-bezier(0.16, 0.84, 0.32, 1);\n}\n\n@keyframes cardIn {\n  from {\n    transform: translateY(20px) scale(0.98);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.input-group {\n  width: 100%;\n}\n\n.input-with-icon {\n  display: flex;\n  align-items: center;\n  background-color: var(--bg-light);\n  border: 1px solid var(--border-light);\n  border-radius: 0.75rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  position: relative; \n}\n\n.input-with-icon:focus-within {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.2);\n}\n\n.input-icon {\n  padding: 0 0.5rem 0 1rem; \n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n.login-input {\n  flex-grow: 1; \n  width: 100%;\n  border: none;\n  background: transparent;\n  padding: 0.85rem 0; \n  font-size: 1rem;\n  color: var(--text-dark);\n  outline: none; \n}\n\n.login-input::placeholder {\n  color: var(--text-muted);\n}\n\n.login-input:focus {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.2);\n}\n\n.password-toggle {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n  cursor: pointer;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n}\n\n.password-toggle:hover {\n  color: var(--brand-primary);\n}\n\n.forgot-password-row {\n  text-align: right;\n  margin-top: -0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.forgot-password-link {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n  text-decoration: none;\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.5rem;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.forgot-password-link:hover {\n  color: var(--brand-primary);\n  background-color: var(--bg-light);\n}\n\n.login-btn {\n  margin-top: 0.5rem;\n  background: linear-gradient(90deg, var(--brand-primary), #02b6a7);\n  color: white;\n  padding: 0.9rem 1.5rem;\n  border-radius: 9999px;\n}\n\n.company-logo-wrapper {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.company-logo {\n  max-width: 160px;\n  width: 100%;\n  height: auto;\n  opacity: 0.75;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
